import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useField } from 'formik';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { loadReference, selectLightFixtures } from '@sophocles/features/reference';

function LightFixtureField({
  required = false,
  size = 'normal',
  fullWidth = false,
  helperText = null,
  defaultValue = '',
  ...props
}) {
  const [field, meta] = useField(props);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadReference());
  }, [dispatch]);

  const fixtureOptions = useSelector(selectLightFixtures)
    .slice()
    .sort((a, b) => (a.watts ?? 0) - (b.watts ?? 0));

  return (
    <FormControl required={required} fullWidth={fullWidth} size={size} error={meta.error != null}>
      <InputLabel id="light-fixture-select-label" htmlFor="light-fixture-select">
        {field.label ?? t('general.lightFixture')}
      </InputLabel>
      <Select
        labelId="light-fixture-select-label"
        id="light-fixture-select"
        value={field.value}
        defaultValue={defaultValue}
        label={field.label ?? t('general.lightFixture')}
        onChange={field.onChange}
        onBlur={event => {
          event.persist();
          event.target = { value: field.value, name: field.name };
          field.onBlur(event);
        }}
        inputProps={{
          name: props.name,
        }}
      >
        {fixtureOptions.map(opt => (
          <MenuItem key={`fixture-option-${_.get(opt, 'id')}`} value={_.get(opt, 'id')}>
            {_.get(opt, 'name', 'Unknown')}
          </MenuItem>
        ))}
      </Select>
      {(helperText || (meta.touched && meta.error)) && (
        <FormHelperText>{meta.touched && meta.error ? meta.error : helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

LightFixtureField.propTypes = {
  required: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'normal', 'large']),
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  defaultValue: PropTypes.string,
};

export default LightFixtureField;
